





























































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
	name: 'PermissionsMessage',
	components: {},
})
export default class PermissionsMessage extends Vue {
	@Prop() private permissions: string;

	constructor() {
		super();
	}

	private created() {
		console.log('permissions', this.permissions);
	}
}
